import {AppCatalogCard} from './AppCatalogCard';
import styles from './Apps.module.css';
import {CatalogApp} from './catalogApp';

export const AppTileGrid = ({apps, withActions}: {apps: CatalogApp[]; withActions?: boolean}) => (
  <div className={styles.appTileGrid}>
    {apps.map((app, index) => (
      <AppCatalogCard
        key={app.id ?? `${app.slug}-${index}`}
        app={app}
        tileLayout
        withActions={withActions}
      />
    ))}
  </div>
);
